export default __webpack_public_path__ + "static/media/canva-pink-feminine-social-media-marketing.d1c644c7.png";